import React, { Component } from 'react';

class WidgetHeader extends Component {
  render() {
    return (
      <div className="border-b py-2 px-3 font-medium flex justify-between items-center">
        <span>{ this.props.widgetTitle }</span>
      </div>
    );
  }
};

export { WidgetHeader };
